import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { UsageScreenProvider, useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { isQa } from '../../utils/env';
import { Subscreens } from '../../constants/usage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getFeedbackSurveyUrl() {
  return isQa() ? 'https://survey.hsformsqa.com/1Gts5cjB_RaW5RhIsfGulZw1nzr9v' : 'https://survey.hsforms.com/1aOqSsquRQYWUgs_20YLUMQ1h';
}
export function NoResults() {
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.NO_RESULTS,
    children: /*#__PURE__*/_jsx(NoResultsContent, {})
  });
}
function NoResultsContent() {
  const params = useSearchParams();
  const search = params.get('search');
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  trackMarketplaceEvent(getMarketplaceInteractionEvent({
    action: 'search dead end reached',
    search
  }));
  const handleFeedbackLinkClick = () => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'feedback survey link clicked'
    }));
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "start",
    gap: "400",
    marginBlockStart: "800",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-600",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.noResults.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.noResults.description"
      })
    }), /*#__PURE__*/_jsxs(Text, {
      typography: "body-100",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.noResults.feedbackText"
      }), ' ', /*#__PURE__*/_jsx(Link, {
        href: getFeedbackSurveyUrl(),
        external: true,
        onClick: handleFeedbackLinkClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.searchResults.noResults.feedbackLinkText"
        })
      }), "."]
    })]
  });
}